/* eslint-disable react/destructuring-assignment */
import { Box } from '@material-ui/core';
import { ControlledInput } from './ControlledInput';
import { Caption } from './Caption';

export function CollectionOrderInput(props: any) {
  return <ControlledInput {...props} style={{ marginTop: 16 }} margin="none" />;
}

export function CollectionOrderCounterInput(props: any) {
  return (
    <Box>
      <ControlledInput {...props} style={{ marginTop: 16 }} margin="none" />
      <Caption style={{ float: 'right' }}>
        {props?.value?.length}/{props?.rules?.maxLength?.value}
      </Caption>
    </Box>
  );
}
